import { plotColors } from '@revelio/replots';

import { usePrimaryFilterState } from '../../../filters/hooks/usePrimaryFilterState';
import { useTabContentConfig } from '../../PageConfigProvider/PageConfigProvider';

export const useActiveColors = () => {
  const { primaryFilter } = useTabContentConfig();
  const { primaryFilter: primaryFilterState } = usePrimaryFilterState(
    primaryFilter?.id
  );

  const { primarySelections } = primaryFilterState ?? {};

  const colorMap = primarySelections
    ?.filter((selection) => selection.isActive)
    .reduce(
      (acc, selection, index) => {
        const entityId = selection.id.split('_').slice(-1)[0];
        const key = `${entityId}_${selection.name}`;
        acc[key] = plotColors[index % plotColors.length] || '#5CA9E9';
        return acc;
      },
      {} as Record<string, string>
    );

  return { colorMap };
};
